require("fslightbox");
import fs from "fslightbox";

export default function () {
  let hrefs = document.querySelectorAll(".gallery-item");

  let gal = "gall";
  for (let i = 0; i < hrefs.length; i++) {
    const element = hrefs[i];
    let uuid = i;
    let href = element.querySelector("a");
    href.setAttribute("data-fslightbox", gal);
    href.setAttribute("href", img);
  }
  setTimeout(() => {
    refreshFsLightbox();
  }, 500);
}
